import store from '@/store';

export default () => {
  const { core: { pages, pagesSelection } } = store.getState();
  const currentPage = pages[pagesSelection[0]];
  const shields = {};

  for (const layoutId in currentPage.layouts) {
    const layout = currentPage.layouts[layoutId];
    for (const groupId in layout.groups) {
      const group = layout.groups[groupId];
      for (const shieldId in group.shields) {
        shields[shieldId] = group.shields[shieldId];
      }
    }
  }

  return shields;
};
